<div style="height: 100%;">
  <ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-scale" [fullScreen] = "true"><p style="color: white" > {{ 'app.loading' | translate }} </p></ngx-spinner>
  <router-outlet></router-outlet>
</div>